import AbstractPage from 'pages/AbstractPage';
import Vue from 'vue';
import Basket from 'components/Basket.vue';

export default class BasketPage extends AbstractPage {
    constructor() {
        super();

        if (app.pageData.basketItems && Object.values(app.pageData.basketItems).length > 0) {
            this.vueComponent = new Vue({
                el: '#basket-container',
                render: h => h(Basket),
                data: {},
                methods: {},
            });
        } else {
            $('.empty-basket').removeClass('hidden');
        }
    }
}

$(function () { app.pageController = new BasketPage(); });
